module.exports = __webpack_public_path__ + "img/出行代步.f8ccb40d.png";